import { useEffect, useRef } from 'react';
// @ts-ignore
import io from 'socket.io-client';

import { REACT_APP_ROBO_API_URL, useObjectsUpdatedWebsockets } from 'lib/queries';
import { useReceiveAnalysisWebsockets } from 'screens/Analysis/lib/queries';
import { useReceiveBacktestWebsockets } from 'screens/Backtest/lib/queries';
import { useAuth, useAuthToken } from 'screens/Login/lib/queries';
import { useReceivePortfolioWebsockets } from 'screens/Portfolio/lib/queries';
import { useReceiveUserWebsocketsAdmin } from 'screens/User/lib/queries';
import { SocketioEvent } from 'utils/constants';

const ROBO_SOCKET_URL = REACT_APP_ROBO_API_URL;
const ROBO_SOCKET_PATH = '/api/socket.io';

const SocketioEventListener = () => {
  const { isAuthenticated } = useAuth();
  const { token } = useAuthToken();
  const socketRef = useRef<ReturnType<typeof io> | null>(null);

  const handleUserInvitationSent = useReceiveUserWebsocketsAdmin(
    SocketioEvent.USER_INVITATION_SENT
  );
  const handleOptimizationStarted = useReceivePortfolioWebsockets(
    SocketioEvent.OPTIMIZATION_STARTED
  );
  const handleOptimizationFinished = useReceivePortfolioWebsockets(
    SocketioEvent.OPTIMIZATION_FINISHED
  );
  const handleBacktestStarted = useReceiveBacktestWebsockets(SocketioEvent.BACKTEST_STARTED);
  const handleBacktestFinished = useReceiveBacktestWebsockets(SocketioEvent.BACKTEST_FINISHED);

  const handleAnalysisStarted = useReceiveAnalysisWebsockets(
    SocketioEvent.PORTFOLIO_ANALYSIS_STARTED
  );
  const handleAnalysisFinished = useReceiveAnalysisWebsockets(
    SocketioEvent.PORTFOLIO_ANALYSIS_FINISHED
  );
  const handleAnalysisPartial = useReceiveAnalysisWebsockets(
    SocketioEvent.PORTFOLIO_ANALYSIS_PARTIAL
  );

  const handleObjectsUpdated = useObjectsUpdatedWebsockets();

  useEffect(() => {
    if (!isAuthenticated || !token) {
      return undefined;
    }

    const socket = io(ROBO_SOCKET_URL, {
      path: ROBO_SOCKET_PATH,
      query: { token },
      transports: ['polling', 'websocket'],
      upgrade: true,
    });
    socketRef.current = socket;

    socket.on(SocketioEvent.USER_INVITATION_SENT, handleUserInvitationSent);
    socket.on(SocketioEvent.OPTIMIZATION_STARTED, handleOptimizationStarted);
    socket.on(SocketioEvent.OPTIMIZATION_FINISHED, handleOptimizationFinished);
    socket.on(SocketioEvent.OBJECTS_UPDATED, handleObjectsUpdated);
    socket.on(SocketioEvent.PORTFOLIO_ANALYSIS_STARTED, handleAnalysisStarted);
    socket.on(SocketioEvent.PORTFOLIO_ANALYSIS_PARTIAL, handleAnalysisPartial);
    socket.on(SocketioEvent.PORTFOLIO_ANALYSIS_FINISHED, handleAnalysisFinished);
    socket.on(SocketioEvent.BACKTEST_STARTED, handleBacktestStarted);
    socket.on(SocketioEvent.BACKTEST_FINISHED, handleBacktestFinished);
    socket.on(SocketioEvent.BACKTEST_CANCELLED, handleBacktestStarted);

    return () => {
      socket.close();
      socketRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, token]);

  return null;
};

export default SocketioEventListener;
